export default "__VITE_ASSET__C3w1LHTE__"